<template>
  <div>


    <HerderHead :pageindex="3"></HerderHead>

    <RitMenlian></RitMenlian>


    <!-- 主题内容 -->
    <div class="mod_1 w1150">

      <div class="nt">
        Company introduction

      </div>
      <div class="dect">
        Looking to save money on everyday household products?

        LocTok is a product trial platform where you can get up to 100% rebates when shopping online!

        LocTok's fundamental aim is to help people find good stuff and test the potential development of new products, while offering fair and  comprehensive trial report for customers. We're the cashback site that gives up to 100% moneyback rebates and we don't charge our members any fees  either; Rebatest is free to join, free to use and free to cash-out. We're also the only few one of cashback platform that doesn't have a minimum  pay-out threshold, and you can cash-out as many times a year as you want.
      </div>

    </div>


    <!--
		<div class="mod_2 w">

			<div class="group cle">
				<div class="it">
					<a href="#">
						<div class="dm">
							<div class="img">
								<img src="../../static/img12.jpg" />
							</div>
							<div class="nt  txtov">
								Product Trial
							</div>
							<div class="dect">
								The merchant and the user are zero distance. The merchant provides the product to be
								tested to the user, the user helps the merchant to test the product and faithfully
								feedbacks the trial experience. The user helps the merchant to continuously improve the
								quality and function of the product, and the merchant provides the user with better
								quality and performance. The benign interaction between merchants and users promotes the
								further improvement of life quality.
							</div>
						</div>
					</a>

				</div>
				<div class="it">
					<a href="#">
						<div class="dm">
							<div class="img">
								<img src="../../static/img11.jpg" />
							</div>
							<div class="nt  txtov">
								Product Trial
							</div>
							<div class="dect">
								The merchant and the user are zero distance. The merchant provides the product to be
								tested to the user, the user helps the merchant to test the product and faithfully
								feedbacks the trial experience. The user helps the merchant to continuously improve the
								quality and function of the product, and the merchant provides the user with better
								quality and performance. The benign interaction between merchants and users promotes the
								further improvement of life quality.
							</div>
						</div>
					</a>

				</div>
				<div class="it">
					<a href="#">
						<div class="dm">
							<div class="img">
								<img src="../../static/img10.jpg" />
							</div>
							<div class="nt  txtov">
								Product Trial
							</div>
							<div class="dect">
								The merchant and the user are zero distance. The merchant provides the product to be
								tested to the user, the user helps the merchant to test the product and faithfully
								feedbacks the trial experience. The user helps the merchant to continuously improve the
								quality and function of the product, and the merchant provides the user with better
								quality and performance. The benign interaction between merchants and users promotes the
								further improvement of life quality.
							</div>
						</div>
					</a>

				</div>
			</div>

		</div>

     -->

    <div class="mod_3">

      <div class="cm_t">
        Advantages of LocTok
      </div>


      <div class="w group cle">

        <div class="it">
          <a href="#">
            <div class="dm">
              <div class="img">
                <img src="../../static/img16.jpg" />
              </div>
              <div class="nt">
                100% Cash Back
              </div>
              <div class="dects">
                Get 100% cash back by placing order
                of trials and giving feedback at Amazon.
              </div>
            </div>
          </a>
        </div>

        <div class="it">
          <a href="#">
            <div class="dm">
              <div class="img">
                <img src="../../static/img17.jpg" />
              </div>
              <div class="nt">
                Huge Amount of Free Trials
              </div>
              <div class="dects">
                We provide many real free products
                and update new items each week.
              </div>
            </div>
          </a>
        </div>


        <div class="it">
          <a href="#">
            <div class="dm">
              <div class="img">
                <img src="../../static/img18.jpg" />
              </div>
              <div class="nt">
                Non-review products
              </div>
              <div class="dects">
                Provide NO Review products each week
                refund after received.
              </div>
            </div>
          </a>
        </div>


        <div class="it">
          <a href="#">
            <div class="dm">
              <div class="img">
                <img src="../../static/img22.jpg" />
              </div>
              <div class="nt">
                Invite Friends
              </div>
              <div class="dects">
                Invite your friends to complete the trial task
                and you will get Commission $10.
              </div>
            </div>
          </a>
        </div>


        <div class="it">
          <a href="#">
            <div class="dm">
              <div class="img">
                <img src="../../static/img23.jpg" />
              </div>
              <div class="nt">
                100% Risk Free
              </div>
              <div class="dects">
                All transactions are done on Amazon
                without any additional fees.
              </div>
            </div>
          </a>
        </div>


        <div class="it">
          <a href="#">
            <div class="dm">
              <div class="img">
                <img src="../../static/img24.jpg" />
              </div>
              <div class="nt">
                Exclusive Customer Service Support
              </div>
              <div class="dects">
                Customer service support to solve any
                problems  encounter on the platform.
              </div>
            </div>
          </a>
        </div>


      </div>


    </div>


    <Footer></Footer>
  </div>
</template>



<script>
//import HelloWorld from '../components/HelloWorld.vue'
import HerderHead from "../components/header.vue"
import Footer from "../components/footer.vue"
import RitMenlian from "../components/rit.vue"

export default {

  components: {

    HerderHead,
    Footer,
    RitMenlian
  },

  data() {
    return {
      data: '',
      hei: null
    }
  },
  methods: {
    getCouname() {
      console.log('111');
    }
  },
  mounted() {

  },
  created() {

    //创建页面执行方法
    console.log(this.data);

  },
}
</script>

<style>
.mod_1 {
  padding: 50px 0;
  text-align: center;
}

.mod_1 .nt {
  font-size: 36px;
  color: #323232;
  font-weight: bold;
  margin-bottom: 35px;
}

.mod_1 .dect {
  font-size: 16px;
  color: #8c8c8c;
  line-height: 30px;
}

.mod_2 {
  padding-bottom: 60px;
}

.mod_2 .it {
  background: #fff;
  width: 30%;
  margin-right: 3%;
  text-align: center;
  box-shadow: rgba(4, 0, 0, 0.2) 0px 0px 10px;
  border-radius: 5px;
  float: left;
}

.mod_2 .it:last-child {
  margin-right: 0px;
}

.mod_2 .it .dm {
  padding: 35px 20px;
  padding-bottom: 30px;

}

.mod_2 .it .dm .nt {
  font-size: 24px;
  font-weight: bold;
  color: #000000;
  margin: 25px 0;
}

.mod_2 .it .dm .dect {
  font-size: 12px;
  color: #666666;
  line-height: 25px;
  text-align: left;
}

.mod_3 {
  background: #f2f2f2;
  padding: 50px 0;
}

.mod_3 .cm_t {
  font-size: 54px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  margin-bottom: 60px;
}

.mod_3 .group .it {
  background: #fff;
  box-shadow: rgba(4, 0, 0, 0.2) 0px 0px 10px;
  border-radius: 10px;
  width: 30%;
  margin-right: 3%;
  margin-bottom: 40px;
  float: left;

}

.mod_3 .group .it:nth-child(3n) {
  margin-right: 0px;
}

.mod_3 .group .it .dm {
  padding: 35px 90px;
  text-align: center;
}

.mod_3 .group .it .dm .nt {
  font-weight: bold;
  color: #333333;
  font-size: 16px;
  margin: 15px 0;
}

.mod_3 .group .it .dm .dects {
  text-align: left;
  color: #838383;
  font-size: 16px;
}

@media screen and (max-width:1200px) {
  .mod_1 {
    padding: 20px 0;
  }

  .mod_1 .nt {
    font-size: 18px;
    margin-bottom: 15px;
  }

  .mod_1 .dect {
    font-size: 14px;
  }

  .mod_2 .it {
    width: 100%;
    margin: 0px;
    margin-bottom: 20px;
  }

  .mod_2 .it:nth-child(3n) {
    width: 100%;
    margin: 0px;
    margin-bottom: 20px;
  }

  .mod_2 .it .dm .img img {
    width: 100px;
  }

  .mod_3 .cm_t {
    font-size: 18px;
    margin-bottom: 20px;
  }

  .mod_3 .group .it {
    width: 100%;
    margin: 0px auto;
    margin-bottom: 20px;
  }

  .mod_3 .group .it:nth-child(3n) {
    width: 100%;
    margin: 0px auto;
    margin-bottom: 20px;
  }

  .mod_3 {
    padding: 20px 0;
  }

  .mod_3 .group .it .dm {
    padding: 20px;
  }
}
</style>
